import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetHistoryByOrderInput } from './GetHistoryByOrderInput';
import { GetHistoryByOrderOutput } from './GetHistoryByOrderOutput';

export class GetHistoryByOrderService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetHistoryByOrderInput): Promise<Result<GetHistoryByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetHistoryByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/history`);
    return promise;
  }
}